import { Appear } from "@components/motion/Appear"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Two Column Rich Text",
  tags: ["#page"],
}

export default defineBlock("content/two-column-rich-text", (props) => {
  return (
    <div className="content-sized my-blockSpace grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-5">
      <Appear slide>
        <EditableText
          className="border-l w-full text-balance type-serif-xl-regular px-5 md:px-4"
          store="title"
          defaultValue="Primary text"
          placeholder="Primary text"
        />
      </Appear>
      <Appear slide delay={150} className="w-full type-serif-lg-regular [&_a]:underline">
        <InnerBlocks
          allowedBlocks={["#inline"]}
          defaultBlocks={[["core/paragraph", { placeholder: "Body text" }]]}
          orientation="vertical"
        />
      </Appear>
    </div>
  )
})
